import React from "react";
import { registerFonts } from "../../badge/pdf/pdfDocument/pdfStyles";
import moment from "moment/moment";
import { FONT, PAPER_SIZE } from "../../types/enums";
import { Document, Image, Link, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { VisaDocumentProps } from "../types";
import PDFUtils from "../../badge/utils/pdfUtils";
import { TextWithFontCheck as TFC } from "../../common/components/textWithFontCheck/TextWithFontCheck";
import { useVisaDocumentFR } from "./hooks/useVisaDocumentFR";
import 'moment/locale/es-mx.js';

const styles = StyleSheet.create({
  footer: {
    minWidth: "596px",
    maxWidth: "596px",
    minHeight: "172px",
    maxHeight: "172px",
    marginTop: "auto"
  },
  logo: {
    minWidth: "596px",
    maxWidth: "596px",
    minHeight: "86px",
    maxHeight: "86px",
    marginBottom: "10px"
  },
  container: {
    fontSize: "10px",
    fontFamily: FONT.HELVETICA,
    paddingLeft: "3cm",
    paddingRight: "3cm",
    paddingBottom: ".5cm",
    lineHeight: '1.2',
  },
  top: {
    minWidth: '50%',
    maxWidth: '75%',
    textAlign: 'left',
    marginLeft: 'auto',
    lineHeight: '1.5',
    marginBottom: '20px'
  },
  addressDetails: {
    marginBottom: '20px'
  },
  personDetails: {
    marginBottom: '15px'
  },
  header: {
    lineHeight: '1.5',
  },
  eventAddress: {
    marginTop: '10px'
  },
  eventDetails: {
    marginBottom: '10px'
  },
  footerUrl: {
    marginTop: '20px'
  },
  orange: {
    color: '#EB683A',
    fontFamily: FONT.HELVETICA_BOLD
  }
});

export const VisaDocumentMXExhibitor: React.FC<VisaDocumentProps> = ({
                                                                       event, person, company, logoSrc, footerSrc
                                                                     }) => {
  registerFonts();
  moment.locale("es-mx");
  const { startDate, endDate } = useVisaDocumentFR(event.dates);
  return (
    <Document>
      <Page size={PAPER_SIZE.A4}>
        <Image style={styles.logo} src={PDFUtils.returnSrc(logoSrc)} />
        <View style={styles.container}>
          <View style={[styles.top]}>
            <Text><Text style={styles.orange}>Expositor</Text> <TFC>{company.name}</TFC></Text>
            <Text><Text style={styles.orange}>Fecha</Text> {moment().format('YYYY MMMM DD')}</Text>
          </View>
          <View style={styles.addressDetails}>
            <Text><Text style={styles.orange}>Nombre en el pasaporte</Text> <TFC>{person.passportData.name}</TFC></Text>
            <Text>Cargo <TFC>{person.position}</TFC></Text>
            <Text>Nombre del empleador ("Empresa") <TFC>{company.name}</TFC></Text>
            <Text>Dirección 1 <TFC>{company.address1}</TFC></Text>
            {!!company.address2 && <Text>Dirección 2 <TFC>{company.address2}</TFC></Text>}
            <Text>Código Postal <TFC>{company.postCode}</TFC></Text>
          </View>
          <View style={styles.personDetails}>
            <Text>Solicitud de visado (Nombre en el pasaporte): <TFC>{person.passportData.name}</TFC></Text>
            <Text>Fecha de nacimiento: <TFC>{moment(person.passportData.dateOfBirth).format('DD MMMM YYYY')}</TFC></Text>
            <Text>Número de pasaporte: <TFC>{person.passportData.passportNumber}</TFC></Text>
          </View>
          <View style={styles.eventDetails}>
            <Text style={[styles.header, styles.orange]}>Estimado Sr./Sra.:</Text>
            <Text>Usted ha expresado su interés en asistir a <TFC>{event.name}</TFC> (el "Evento"), que es organizado por Reed
              Exhibitions, una división de RELX Inc ("RX") en México. RX el principal organizador mundial de
              exposiciones comerciales y de consumo, organiza más de 500 eventos en casi 30 países, atrayendo a más de
              7.000.000 participantes. Su asistencia al evento <TFC>{event.name}</TFC> será como un representante de la compañía
              arriba mencionada misma que estará exponiendo en el evento como expositor.
            </Text>
            <Text style={styles.eventAddress}>
              El evento está programado para celebrarse en <TFC>{event.venue}</TFC> (Nombre del recinto)
              en <TFC>{event.city}</TFC> (Ciudad), México, los
              días {startDate} - {endDate} y a RX le gustaría que estuviera presente.
            </Text>
          </View>
          <View>
            <Text style={[styles.header, styles.orange]}>Esta invitación involucra lo siguiente:</Text>
            <Text>1) El viaje de <TFC>{person.passportData.country}</TFC> a <TFC>{event.state || event.city}</TFC></Text>
            <Text>2) La empresa mencionada anteriormente será la única responsable de pagar todos los costos de su viaje (avión, hotel, etc.).</Text>
            <Text>
              3) Los días del evento son del {startDate} - {endDate} y se necesitan fechas adicionales antes y después del evento para la instalación y el desmontaje de los stands, así como para las reuniones con los clientes.
            </Text>
          </View>
          <Text style={styles.footerUrl}>
            Por favor tenga en cuenta que, aunque RX MX desea que usted asista al Evento, queda en la entera discreción del Gobierno de México determinar si le concede o no emitir una visa para entrar al país. Para obtener más información
            sobre el evento, por favor acceda al sitio web oficial del evento: <Link src={event.websiteUrl}>{event.websiteUrl}</Link>
          </Text>
        </View>
        <Image style={styles.footer} src={PDFUtils.returnSrc(footerSrc)} />
      </Page>
    </Document>
  );
};
